import { render, staticRenderFns } from "./PageDietaryGoal.vue?vue&type=template&id=6f7a5d0a"
import script from "./PageDietaryGoal.vue?vue&type=script&lang=js"
export * from "./PageDietaryGoal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports